import Styles from "./TabNavBar.module.scss";
import { TabNavBarItem } from "../TabNavBarItem/TabNavBarItem";
import cn from "classnames";

type TabNavBarOption = {
  label: string;
  path: string;
  active: boolean;
  isEvent: boolean;
  "data-testid": string;
  isShowing: boolean;
};

export interface TabNavBarProps {
  options: TabNavBarOption[];
  className: string;
}

export const TabNavBar = ({ options, className }: TabNavBarProps) => {
  return (
    <div className={cn(Styles.tabItems, className)}>
      {options
        .filter((option) => option.isShowing)
        .map((option) => {
          return (
            <TabNavBarItem
              key={option["data-testid"]}
              label={option.label}
              path={option.path}
              active={option.active}
              isEvent={option.isEvent}
              data-testid={option["data-testid"]}
            />
          );
        })}
    </div>
  );
};
